export default __webpack_public_path__ + "app/assets/running-cat-35e35eaf.gif";